// Get Lookbook Limits
export const GET_LOOKBOOK_LIMITS_REQUEST = 'GET_LOOKBOOK_LIMITS_REQUEST';
export const GET_LOOKBOOK_LIMITS_DONE = 'GET_LOOKBOOK_LIMITS_DONE';
export const GET_LOOKBOOK_LIMITS_FAILED = 'GET_LOOKBOOK_LIMITS_FAILED';
